export default class Stopwatch {
  startTime = null
  constructor () {
    this.start();
  }

  start () {
    if (this.startTime !== null) {
      console.error('Stopwatch already started');
      return;
    }
    this.startTime = performance.now();
    return this;
  }

  stop () {
    const elapsedTime = performance.now() - this.startTime;
    this.startTime = null;
    return elapsedTime;
  }
}
